import React, { useEffect, useState } from "react";
import styles from "./Header.module.scss";
import logo from "../../assets/images/logo.svg";
import { Link, useLocation } from "react-router-dom";
import { Modal } from "@mui/material";
import LoginModal from "../Authentication/LoginModal";
import VerifyModal from "../Authentication/VerifyModal";
import { useDispatch, useSelector } from "react-redux";
import { userSelector } from "../../redux/Selectors";
import mobileMenuIcon from "../../assets/icons/mobileMenu.svg";
import userIcon from "../../assets/icons/user.svg";
import MobileMenu from "./MobileMenu";
import { useTranslation } from "react-i18next";
import {
  openLoginModal,
  setUserFromStorage,
} from "../../redux/slices/authSlice";
import axios from "axios";
import { getLangFromPath } from "../../utils/getLangFromPath ";
const Header = () => {
  const { t } = useTranslation();

  const [landingHeader, setLandingHeader] = useState();
  const location = useLocation();
  useEffect(() => {
    if (location.pathname === "/${lang}/" || location.pathname === "/ar/") {
      setLandingHeader(true);
    } else {
      setLandingHeader(false);
    }
  }, [location]);

  const user = useSelector(userSelector);
  const [verifyModal, setVerifyModal] = useState(false);
  const [openedMenu, setOpenedMenu] = useState(false);
  const [verifyData, setVerifyData] = useState();
  const dispatch = useDispatch();
  const openedModal = useSelector((state) => state.authSlice.openedModal);
  const handleOpen = () => {
    dispatch(openLoginModal(true));
  };
  const lang = getLangFromPath();
  const handleClose = () => {
    setVerifyModal(false);
    dispatch(openLoginModal(false));
  };
  const handleVerify = (email, password, passwordConfirm) => {
    const tempData = {
      email,
      password,
      passwordConfirm,
    };
    setVerifyData(tempData);
    setVerifyModal(!verifyModal);
  };
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
      dispatch(setUserFromStorage());
    }
  }, [dispatch]);
  return (
    <div className={landingHeader ? styles.landingHeader : styles.wrapper}>
      <div className={styles.left}>
        <Link to={`/${lang}/`}>
          <img className={styles.logo} src={logo} />
        </Link>
        <ul>
          <li>
            <Link to={`/${lang}/buy`}>{t("header.buy")}</Link>
          </li>
          <li>
            <Link to={`/${lang}/rent`}>{t("header.rent")}</Link>
          </li>
          <li>
            <Link to={`/${lang}/commercial`}>{t("header.commercial")}</Link>
          </li>
          <li>
            <Link to={`/${lang}/new-projects`}>{t("header.new-projects")}</Link>
          </li>
          <li>
            <Link to={`/${lang}/find-agent`}>{t("header.find-agent")}</Link>
          </li>
          <li>
            <Link to={`/${lang}/mortgages`}>{t("header.mortgages")}</Link>
          </li>
          <li>
            <Link to={`/${lang}/contact-us`}>{t("header.contact-us")}</Link>
          </li>
        </ul>
      </div>

      {user ? (
        <Link to={`/${lang}/my-account`} className={styles.userDiv}>
          <img src={userIcon} alt="" />
        </Link>
      ) : (
        <button onClick={handleOpen} className={styles.loginBtn}>
          {t("header.login-btn")}
        </button>
      )}
      <div
        className={styles.mobileMenuIcon}
        onClick={() => setOpenedMenu(true)}
      >
        <img src={mobileMenuIcon} alt="" />
      </div>

      <Modal open={openedModal} onClose={handleClose}>
        {verifyModal ? (
          <VerifyModal
            data={verifyData}
            handleVerify={handleVerify}
            handleClose={handleClose}
          />
        ) : (
          <LoginModal handleVerify={handleVerify} handleClose={handleClose} />
        )}
      </Modal>
      {openedMenu && <MobileMenu setOpenedMenu={setOpenedMenu} />}
    </div>
  );
};

export default Header;
